<template>
  <div id="kj-app">
    <BargainDetail></BargainDetail>
  </div>
</template>

<script>
import BargainDetail from 'components/bargainDetail'

export default {
  components: {
    BargainDetail
  }
}
</script>

<style scoped>
#kj-app {
  font-size: 14px;
  color: #333;
  overflow-scrolling: touch;
  background-color: #fff;
  font-family: "PingFang SC", Lantinghei, "Microsoft YaHei", "Helvetica Neue", Helvetica, "Lucida Grande", STHeiTi, Arial, sans-serif;
}
</style>



// WEBPACK FOOTER //
// App.vue?756b0bb4